const ManageContestQueryKeys = {
  CREATE_CONTEST: () => ['create', 'init'],
  EDIT_CONTEST: (contestId: string) => ['edit', 'init', contestId],
  RESTART_CONTEST: (contestId: string) => ['restart', 'init', contestId],
};

export default ManageContestQueryKeys;
